import { userService } from "@/common/services/UserService";
import { Access } from "@/common/models/Access";
import { UserRole } from "@/common/enums/UserRole";
import { AccessLevel } from "@/common/enums/AccessLevel";
import { storeService } from "@/common/services/StoreService";

class AccessService {
  hasAccessToDashboard(): boolean {
    return false;
  }

  hasAccessToPickingPortal(): boolean {
    return storeService.stores.length > 0;
  }

  hasAccessToAllergens(): boolean {
    return false;
  }

  hasAccessToDataUploader(): boolean {
    return false;
  }

  hasAccessToOffers(): boolean {
    return false;
  }

  hasAccessToProductLocations(): boolean {
    return false;
  }

  hasAccessToProducts(): boolean {
    return false;
  }

  hasAccessToPurchaseReports(): boolean {
    return false;
  }

  hasAccessToSeasonalHeader(): boolean {
    return false;
  }

  hasAccessToStores(): boolean {
    return this.hasAdminRole();
  }

  hasAccessToAllReceipts(): boolean {
    return this.hasAdminRole();
  }

  hasAccessToStoreReceipts(): boolean {
    return this.hasAdminRole() || this.hasAdminAccess();
  }

  hasAccessToUserAccounts(): boolean {
    return false;
  }

  hasAccessToUserAdministration(): boolean {
    return this.hasAdminRole() || this.hasAdminAccess() || this.hasManagerAccess();
  }

  hasAccessToAisleCategory(): boolean {
    return this.hasAdminRole();
  }

  hasAdminRole(): boolean {
    return userService.currentUser?.roles.some((role: string) => role === UserRole.ADMIN) === true;
  }

  hasAdminAccess(): boolean {
    return userService.currentUser?.access?.some((access: Access) => access.accessLevel === AccessLevel.ADMIN) === true;
  }

  hasManagerAccess(): boolean {
    return (
      userService.currentUser?.access?.some((access: Access) => access.accessLevel === AccessLevel.MANAGER) === true
    );
  }
}

export const accessService = new AccessService();
